<template>
	<div class="cw-product">
		产品
  	</div>
</template>

<script>

export default {

	data() {
		return {

		}
	},

	computed: {
      
    },

	created() {

	},

	mounted() {

	},

	methods: {

	}
}
</script>

<style lang="scss" scoped>
.cw-product {
    padding-top: 104px;
    font-size: 12px;
}
</style>

